var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(v,k){return _c('el-checkbox',{key:k,attrs:{"label":k}},[_vm._v(_vm._s(v))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }